// 1 : 관리자
// 100 : 관리자(업체)   // 서울우유 대표 계정 (모든 권한)
// 200 : 운영자(업체)   // 서울우유 운영 계정 (차량,단말,계정,그룹 관리)
// 300 : 운영자(그룹)   // 서울우유 하위그룹의 운영 계정 (??)
// 1000 : 운전자        // 서울우유 운전자 계정
// 99999 : 일반사용자   // 미정
// if(limitLevel > userGroupId) ==> show menu
export const MainMenuItems:any[] = [
    // {
    //     id:"menu-01"
    //     ,title:"메인"
    //     ,icon:"mdi mdi-google-maps font-24"
    //     ,limitGroupId:300
    //     ,path:"#"
    //     ,pathInfo:[
    //         {
    //             limitGroupId:300
    //             ,path:"/dtg/car/current/list"
    //         }
    //     ]
    // }
    // ,{
    //     id:"menu-05"
    //     ,title:"메인2"
    //     ,icon:"mdi mdi-google-maps font-24"
    //     ,limitGroupId:300
    //     ,path:"#"
    //     ,pathInfo:[
    //         {
    //             limitGroupId:300
    //             ,path:"/dtg/car/last/total"
    //         }
    //     ]
    // }
    {
        id:"menu-02"
        ,title:"운행일지"
        ,icon:"mdi mdi-clipboard-check font-24"
        ,limitGroupId:300
        ,limitEnv:["local","stg","prod"]
        ,path:"#"
        ,pathInfo:[
            {
                limitGroupId:300
                ,path:"/dtg/analytics/dashboard"
            }
        ]
    }
    ,{
        id:"menu-03"
        ,title:"리포트"
        ,icon:"mdi mdi-chart-bar font-24"
        ,limitGroupId:300
        ,limitEnv:["local","stg","prod"]
        ,path:"#"
        ,pathInfo:[
            {
                limitGroupId:300
                ,path:"/dtg/analytics/drive/safe/summary"
            }
        ]
    }
    ,{
        id:"menu-04"
        ,title:"환경설정"
        ,icon:"mdi mdi-checkbox-marked-outline font-24"
        ,limitGroupId:300
        ,limitEnv:["local","stg","prod"]
        ,path:"#"
        ,pathInfo:[
            {
                limitGroupId:300
                ,path:"/dtg/manage/main"
            }
            ,{
                limitGroupId:200
                ,path:"/dtg/manage/main"
            }
        ]
    }
    ,{
        id:"menu-05"
        ,title:"테스트"
        ,icon:"mdi mdi-flask-outline font-24"
        ,limitGroupId:1
        ,limitEnv:["local"]
        ,path:"#"
        ,pathInfo:[
            {
                limitGroupId:1
                ,path:"/dtg/test/t01"
            }
        ]
    }
];